<template>
  <div class="navbar">
    <div class="grid-2">
      <div>
        <router-link to="/" class="logo"><img src="@/assets/obwan-logo-transparent.png" alt=""></router-link>
      </div>
      <div class="info">
        <button class="small grey" @click="logout">Sign out</button>
        <div>{{ email }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { logout } from './../utils/auth';
export default {
  name: 'Navbar',
  computed: {
    email () { return this.$store.state.user.email; }
  },
  data () {
    return {
    }
  },
  methods: {
    logout () {
      logout();
    }
  }
}
</script>
<style lang="scss" scoped>
.navbar{
  margin: 25px 0 25px 0;
  user-select: none;
  .logo{
    height: 45px;
    img{ height: 45px; }
  }
  .info{
    padding-top: 12px;
    div {
      float: right;
      font-size: 14px;
      line-height: 25px;
    }
    button {
      float: right;
      margin-left: 20px;
    }
  }
}
</style>
